import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import App from './App';
import ESport from './esport_payment/esport';
import OlhmsRequest from './olhms_delete_account_request/RequestPage';
import TelcoMasterRequest from './telcomaster_delete_acount_request/DeletePage';
import HeurekkaRequest from './heurekka_req_delete/heurekka_request_delete';
import QuickAgentDeleteRequest from './quick_agent_req_delete/quick_agent_req_delete';
import PrivacyPolicy from './quick_agent_req_delete/privacy_policy';
import Avatar from './avatar';
import TApp from './treasure_animeFlix/TApp';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Default (homepage) */}
        <Route path="/" element={<div/>} />
        <Route path="/delete-request" element={<QuickAgentDeleteRequest />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
 
        {/* <Route path="/app" element={<App />} />
        <Route path="/esport" element={<ESport />} />
        <Route path="/olhms-delete-request" element={<OlhmsRequest />} />
        <Route path="/telcomaster-delete-request" element={<TelcoMasterRequest />} />
        <Route path="/heurekka-delete-request" element={<HeurekkaRequest />} />
         
 
        <Route path="/avatar" element={<Avatar name_of_airbender="Samuel" name="Bisola" />} />
        <Route path="/treasure-animeflix" element={<TApp />} /> */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();